export const pageQueryName = 'page';
export const pageSizeQueryName = 'pageSize';

export const FIRST_PAGE = 1;
export const PAGE_SIZE_5 = 5;
export const PAGE_SIZE_10 = 10;
export const PAGE_SIZE_25 = 25;
export const PAGE_SIZE_50 = 50;
export const PAGE_SIZE_100 = 100;
export const PAGE_SIZE_250 = 250;
export const PAGE_SIZE_500 = 500;
export const allowablePageSizes = [PAGE_SIZE_50, PAGE_SIZE_100, PAGE_SIZE_250, PAGE_SIZE_500];

export const calculatePagingStats = (page = FIRST_PAGE, pageSize = PAGE_SIZE_250, totalRecords) => {
  const notAllValuesSupplied = !page || !pageSize || !totalRecords;
  const notAllValuesAreNumbers =
    Number.isNaN(parseInt(page, 10)) || Number.isNaN(parseInt(pageSize, 10)) || Number.isNaN(parseInt(totalRecords, 10));
  if (notAllValuesSupplied || notAllValuesAreNumbers) {
    return {
      page,
      pageSize,
      totalRecords,
      totalPages: 0,
      viewStartingCount: 0,
      viewEndingCount: 0,
    };
  }
  const totalPages = Math.ceil(totalRecords / pageSize);
  const viewStartingCount = page === FIRST_PAGE ? FIRST_PAGE : (page - 1) * pageSize + 1;
  const recordsLeftOver = totalRecords - (viewStartingCount - 1);
  const viewEndingCount = recordsLeftOver < pageSize ? totalRecords : viewStartingCount - 1 + pageSize;
  return {
    page,
    pageSize,
    totalRecords,
    totalPages,
    viewStartingCount,
    viewEndingCount,
  };
};

export const getFilteredPagingStats = (newPage, pageSize, totalRecords, oldPageSize) => {
  const realPageSize = pageSize || oldPageSize;
  let newPageWithFallback = newPage;
  if (realPageSize !== oldPageSize) {
    newPageWithFallback = FIRST_PAGE;
  }
  const pagingStats = calculatePagingStats(newPageWithFallback, realPageSize, totalRecords);

  return {
    ...pagingStats,
    isLoading: true,
  };
};

export const getPaginationDataFromLocation = (location = window.location) => {
  const search = new URLSearchParams(location.search);
  const pagingStats = {
    page: search.get(pageQueryName) || 1,
    pageSize: search.get(pageSizeQueryName) || 250,
  };
  return pagingStats;
};

export const getNewStateFromPagingData = (state, newPage, pageSize) => {
  const filteredPagingStats = getFilteredPagingStats(newPage, pageSize, state.totalRecords, state.pageSize);
  return {
    ...state,
    isLoading: true,
    ...filteredPagingStats,
  };
};
